import * as classnames from "classnames";

import { Block, LeftBlock, RightBlock, Button, Msg } from "..";
import HealthCheckModel from "../../models/HealthCheck.model";

/**
 * Prop interface
 */
export interface PoorHealthProps {
  className?: string;
  health: HealthCheckModel;
  showJumpButton?: boolean;
  showWarning?: boolean;
  onOpenHealth?: () => void;
}

/**
 * React Component
 */
export default function PoorHealth({
  className,
  health,
  showJumpButton,
  showWarning,
  onOpenHealth,
}: PoorHealthProps) {
  const rootStyle = classnames("code-c-poor-health", {
    [`${className}`]: Boolean(className),
  });

  return (
    <Block className={rootStyle} role="alert">
      <LeftBlock className="code-c-poor-health__left">
        <span className="code-c-poor-health__poor-icon" />
        <span className="code-c-poor-health__title">
          <Msg id={showJumpButton ? "health.poor.withDetail" : "health.poor"} />
        </span>
      </LeftBlock>
      <RightBlock>
        {showWarning && (
          <span>
            <Msg id={"common.warning"} />: {health.errorCount()}
          </span>
        )}
        {showJumpButton && (
          <Button
            size={"small"}
            shrink={true}
            onClick={() => typeof onOpenHealth === "function" && onOpenHealth()}
            ariaLabel="Open System Checker"
          >
            <Msg id={"action.seeDetails"} />
          </Button>
        )}
      </RightBlock>
    </Block>
  );
}
